
import { Controller } from "stimulus";

export default class extends Controller {

  static targets = ["amount", "inputAmount", "lblAmountPreVat", "chkIncludeTax", "taxRate", "vatPanel", "lblVat", "vatAmount"]
  connect(){
    console.log("taxable controller reporting for duty")
  }

  amountChanged(_event, element) {

    this.taxIncludedClick()
  }
  

  taxIncludedClick(_event, element) {
    const chkIncludeTax = this.chkIncludeTaxTarget
    const inputAmount = this.inputAmountTarget.value
    const taxRate = this.taxRateTarget.value || 15

    if (chkIncludeTax.checked){
      this.vatPanelTarget.style.display = 'block';

      this.taxRateTarget.value = taxRate ;
      const prevatAmount = (inputAmount / (1 + (taxRate / 100))).toFixed(2)
      const vat = (inputAmount - prevatAmount).toFixed(2)
      this.amountTarget.value = prevatAmount;
      this.vatAmountTarget.value = vat;

      this.lblAmountPreVatTarget.innerHTML = format_currency_simple(prevatAmount);
      this.lblVatTarget.innerHTML = format_currency_simple(vat);
      
    }
    else{
      this.vatPanelTarget.style.display = 'none';
      this.amountTarget.value = inputAmount;
      this.vatAmountTarget.value = '';
    }

  }


}